import { InputProps } from '@chakra-ui/react';
import { FC } from 'react';
import AppFormControl from './AppFormControl';

import TextInput from 'presentation/components/shared/fields/TextInput';

interface Props extends Omit<InputProps, 'name'>, FormFieldProps {}

const FormTextInput: FC<Props> = ({
  label,
  helperText,
  subLabel,
  ...props
}) => {
  return (
    <AppFormControl
      name={props.name}
      label={label}
      helperText={helperText}
      subLabel={subLabel}
    >
      <TextInput {...props} />
    </AppFormControl>
  );
};

export default FormTextInput;
